exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".height-initial {\n  height: initial;\n}\n\n.catalog-card-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.search-details-card-width {\n  width: 100%;\n}\n\n.search-review-modal-width-product {\n  width: 600px;\n}\n\n.search-review-modal-width-catalog {\n  width: 90vw;\n}\n\n", ""]);

// exports
